<ng-container *ngIf="!!title">
  <mat-card-subtitle>
    {{ title.key | translate: title.params }}
  </mat-card-subtitle>
</ng-container>
<ng-content />
